import { render, staticRenderFns } from "./UploadDocumentsPage.vue?vue&type=template&id=3051eb8a&scoped=true&"
import script from "./UploadDocumentsPage.vue?vue&type=script&lang=ts&"
export * from "./UploadDocumentsPage.vue?vue&type=script&lang=ts&"
import style0 from "./UploadDocumentsPage.vue?vue&type=style&index=0&id=3051eb8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3051eb8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VExpandTransition,VIcon,VInput,VRadio,VRadioGroup,VRow})
